// extracted by mini-css-extract-plugin
export var disclaimerWrapper = "LegalDisclaimer-module--disclaimer-wrapper--28s37";
export var contentWrapper = "LegalDisclaimer-module--content-wrapper--1GKPG";
export var disclaimerHeadline = "LegalDisclaimer-module--disclaimer-headline--1jq1-";
export var disclaimerContent = "LegalDisclaimer-module--disclaimer-content--3FfdZ";